import { render } from "./ConfirmUser.vue?vue&type=template&id=5b00cae2&scoped=true"
import script from "./ConfirmUser.vue?vue&type=script&lang=js"
export * from "./ConfirmUser.vue?vue&type=script&lang=js"

import "./ConfirmUser.vue?vue&type=style&index=0&id=5b00cae2&scoped=true&lang=css"
import "./ConfirmUser.vue?vue&type=style&index=1&id=5b00cae2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b00cae2"]])

export default __exports__